import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

import { SetDigitizedAssetData } from 'editor/src/util/postMessages/messages';

const addDigitizedAssetReducer = (state: DesignState, action: PayloadAction<SetDigitizedAssetData>) => {
  const { elementId, ...rest } = action.payload;

  // Clear all existing digitized assets for the same element UUID
  // This prevents accumulation of multiple digitized assets when resizing/updating elements
  if (rest.payload && 'elementUuid' in rest.payload && rest.payload.elementUuid) {
    const { elementUuid } = rest.payload;
    const keysToDelete = Object.keys(state.digitizedAssets).filter((key) => {
      const asset = state.digitizedAssets[key];
      return asset.payload && 'elementUuid' in asset.payload && asset.payload.elementUuid === elementUuid;
    });

    keysToDelete.forEach((key) => {
      delete state.digitizedAssets[key];
    });
  }

  // Add the new digitized asset
  state.digitizedAssets[elementId] = rest;
};

export default addDigitizedAssetReducer;
